




























import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import { NoveltyCampaign } from '@/models/novelty/novelty'
import { CampaignConstraint } from '@/usecases/novelty/campaign-constraint'
import { CampaignSummary } from '@/usecases/novelty/campaign-summary'
import { formatPrice } from '@/util/format'
import { PluginMixin } from '@spa/mixins/plugin'
import { NoveltyEntity } from './selection'

@Component
export default class NoveltyCampaignSummarySection extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  noveltyCampaign: NoveltyCampaign

  @Prop({ required: true })
  entities: NoveltyEntity[]

  @Prop({ required: true })
  noveltySummary: CampaignSummary

  get constraint(): CampaignConstraint {
    return new CampaignConstraint(this.noveltySummary)
  }

  get isValid(): boolean {
    return this.constraint.isValid
  }

  get basePriceToSelectNovelty(): number {
    return this.noveltySummary.basePriceToSelectNovelty
  }
  get minimumRequiringPrice(): number {
    return this.noveltySummary.minimumRequiringPrice
  }

  get restOfPriceToSelectNovelty(): string {
    return formatPrice(this.minimumRequiringPrice - this.basePriceToSelectNovelty)
  }
}
